<script>
import { IconCirclePlus, IconCircleMinus } from "@/components/icons/index";
import numberHelper from "@/helpers/numberHelper";

export default {
  name: "AppInputStepper",

  components: {
    IconCirclePlus,
    IconCircleMinus,
  },

  props: {
    value: { type: [String,Number], default: null },
    disabled: { type: Boolean, default: false },
  },

  watch: {
    value(val) {
      if (val < 0) this.updateValue(0)
    }
  },

  methods: {
    increaseValue() {
      this.$emit('increase');
    },
    decreaseValue() {
      if (this.value > 0) this.$emit('decrease');
    },
    updateValue(value) {
      this.$emit('input', value)
    },
    isNumber(input) {
      numberHelper.isNumber(input);
    },
  }
};
</script>

<template>
  <div class="d-flex align-items-center gap-3">
    <span
      role="button"
      class="select-none"
      :class="[{ 'opacity-50 pe-none': value <= 0 || disabled }]"
      @click.prevent="decreaseValue"
    >
      <IconCircleMinus />
    </span>
    <input
      :value="value"
      type="number"
      placeholder=""
      class="form-control text-center"
      :style="{ width: '128px' }"
      @keyup="updateValue($event.target.value)"
      @keypress="isNumber($event)"
      :disabled="disabled"
    />
    <span
      role="button"
      class="select-none"
      @click.prevent="increaseValue"
      :class="[{ 'opacity-50 pe-none': disabled }]"
    >
      <IconCirclePlus />
    </span>
  </div>
</template>

<style lang="scss" scoped>
.dot {
  height: 9px;
  width: 9px;
  border-radius: 50%;
  display: inline-block;
}
</style>
